import React, { Fragment } from 'react';
import { RenderNumberPercentage, RenderGramos } from 'Utils/renderField/renderReadField';

/**
 * Componente para renderizar la tabla de DRC
 * Se creó para refactorizar el contenido en el componente general (LaboratorioForm)
 * Solo se hicieron cambios respectivos a la variación DRC
 * @param {*} props propiedades del componente
 * @returns {JSX.Element} componente de tabla de DRC
 */
export const TablaDRC = (props) => {
    const { fields, setDRCTemp, openModal,
        loadDataModalDRC, updateData, variacionDRC = {}, mostrarVariacionDRC } = props;

    return (
        <Fragment>
            <div className="new-table-wrapper pd-small">
                <table>
                    <thead>
                        <tr>
                            <th />
                            {variacionDRC.aplica && mostrarVariacionDRC ?
                                <Fragment>
                                    <th className="text-right">PESO SECO ORIGINAL</th>
                                    <th className="text-right">PESO SECO CON VARIACIÓN DRC</th>
                                </Fragment>
                                :
                                <th className="text-right">PESO SECO</th>
                            }
                            <th className="text-right">PESO PLATO</th>
                            <th className="text-right">PESO HÚMEDO</th>
                            <th className="text-right">DRC</th>
                            <th className="text-right">HORA INGRESO</th>
                            <th className="text-right">HORA SALIDA</th>
                            <th >LABORATORISTA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((pago, index) => {
                            const dato_actual = fields.get(index); // Pago actual
                            let todos = fields.getAll();
                            todos[index]['index'] = index; //Mutar cada fila par agregarle el index

                            const celdaClassName = (dato_actual.activo !== undefined && dato_actual.activo === false) ? 'tachado' : '';

                            return (
                                <tr key={index} >
                                    <td>
                                        <div className="table-actions">
                                            <img src={require('assets/img/icons/borrar.png')} alt="Borrar"
                                                title="Borrar" className="action_img"
                                                onClick={() => {
                                                    if (dato_actual.hasOwnProperty('id')) {
                                                        dato_actual.activo = false;
                                                        updateData(dato_actual, 'drc');
                                                        setDRCTemp('test', false)
                                                    } else
                                                        fields.remove(index)
                                                }}
                                            />
                                            <img src={require('assets/img/icons/editar.png')} alt="Editar"
                                                title="Editar" className="action_img"
                                                onClick={() => {
                                                    loadDataModalDRC(dato_actual);
                                                    openModal("drc");
                                                    if(dato_actual.laboratorista) setDRCTemp('laboratorista', dato_actual.laboratorista);
                                                    else setDRCTemp('laboratorista', dato_actual.laboratorista_asignado);
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td
                                        label="PESO SECO"
                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                        <RenderGramos value={dato_actual.peso_seco_original} />
                                    </td>
                                    {variacionDRC.aplica && mostrarVariacionDRC &&
                                        <Fragment>
                                            <td
                                                label="PESO SECO CON VARIACIÓN DRC"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                <RenderGramos value={dato_actual.peso_seco} />
                                            </td>
                                        </Fragment>
                                    }
                                    <td
                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                        <RenderGramos value={dato_actual.peso_plato_ajustado} />
                                    </td>
                                    <td
                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                        <RenderGramos value={dato_actual.peso_humedo} />
                                    </td>
                                    <td
                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                        {dato_actual.total ? <RenderNumberPercentage value={dato_actual.total} /> : '--'}
                                    </td>
                                    <td
                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                        <span>{dato_actual.hora_ingreso} </span>
                                    </td>
                                    <td
                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                        <span>{dato_actual.hora_salida} </span>
                                    </td>
                                    <td
                                        className={`${celdaClassName} `}>
                                        <span>{dato_actual.laboratorista_nombre ? dato_actual.laboratorista_nombre : dato_actual.laboratorista.nombre}</span>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
};
